<script>
import EcButton from '../ui/EcButton.vue'
import { useMailV2Store } from '../../stores/mailV2'

export default {
  name: 'MailV2TemplatePreview',
  components: { EcButton },
  props: {
    holderType: { type: String, required: true },
    holderId: { type: [String, Number], required: true },
    templateId: { type: Number, default: null },
    mailTypeId: { type: Number, default: null },
    locales: { type: Array, default: function () { return ['fr', 'en'] } },
    autoLoad: { type: Boolean, default: false },
  },
  data: function () {
    return {
      store: useMailV2Store(),
      activeLocale: 'fr',
      htmlContent: '',
      loading: false,
    }
  },
  watch: {
    activeLocale: function () {
      this.loadPreview()
    },
  },
  mounted: function () {
    if (this.autoLoad) {
      this.loadPreview()
    }
  },
  methods: {
    async loadPreview() {
      if (!this.templateId && !this.mailTypeId) return
      this.loading = true
      try {
        var result = await this.store.previewTemplate(this.holderType, this.holderId, {
          template_id: this.templateId != null ? this.templateId : undefined,
          mail_type_id: this.mailTypeId != null ? this.mailTypeId : undefined,
          locale: this.activeLocale,
        })
        this.htmlContent = typeof result === 'string' ? result : (result && result.html ? result.html : '')
        this.updateIframe()
      } finally {
        this.loading = false
      }
    },
    updateIframe: function () {
      var iframe = this.$refs.iframeRef
      if (!iframe) return
      var doc = iframe.contentDocument
      if (doc) {
        doc.open()
        doc.write(this.htmlContent)
        doc.close()
      }
    },
    injectHtml: function (html) {
      this.htmlContent = html
      this.updateIframe()
    },
  },
}
</script>

<template>
  <div class="ec-mv2-preview">
    <div class="ec-mv2-preview-header">
      <div class="ec-mv2-preview-locales">
        <button
          v-for="loc in locales"
          :key="loc"
          class="ec-mv2-locale-tab"
          :class="{ 'ec-mv2-locale-tab--active': activeLocale === loc }"
          @click="activeLocale = loc"
        >
          {{ loc.toUpperCase() }}
        </button>
      </div>
      <EcButton variant="outline-secondary" size="sm" icon="arrow-clockwise" @click="loadPreview">
        {{ $ecTranslate('MV2.REFRESH') }}
      </EcButton>
    </div>

    <div class="ec-mv2-preview-body">
      <div v-if="loading" class="ec-mv2-preview-loading">
        <ec-spinner />
      </div>
      <iframe
        v-show="!loading && htmlContent"
        ref="iframeRef"
        class="ec-mv2-preview-iframe"
        sandbox="allow-same-origin"
      />
      <div v-if="!loading && !htmlContent" class="ec-mv2-preview-empty">
        <i class="bi bi-envelope-open" style="font-size:32px;color:#ccc;" />
        <p>{{ $ecTranslate('MV2.PREVIEW_HINT') }}</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.ec-mv2-preview {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.ec-mv2-preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
}
.ec-mv2-preview-locales {
  display: flex;
  gap: 2px;
  background: #f0f0f0;
  border-radius: 6px;
  padding: 2px;
}
.ec-mv2-locale-tab {
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 600;
  border: none;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
}
.ec-mv2-locale-tab--active {
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  color: var(--ec-primary-color, #0091ca);
}
.ec-mv2-preview-body {
  flex: 1;
  border: 1px solid var(--ec-border-color, #e9ecef);
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  min-height: 300px;
  position: relative;
}
.ec-mv2-preview-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
.ec-mv2-preview-loading,
.ec-mv2-preview-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 200px;
  color: #999;
  gap: 8px;
}
.ec-mv2-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  font-size: 13px;
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid var(--ec-border-color, #dee2e6);
  background: #fff;
}
.ec-mv2-btn--sm {
  padding: 4px 10px;
  font-size: 12px;
}
</style>
